exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.copyright-search-wrap[data-v-60dd9ef8] {\n  background-color: white;\n}\n", ""]);

// exports
